"use client";

import cn from "@casino/external/classNames";
import { GameThumb as BaseGameThumb } from "@workspace/frontend-ui";
import type { ReactNode } from "react";

type Props = {
  game: GameFragment;
  image: ReactNode;
  size: "auto" | "normal";
};

const ComingSoonGameThumb: FC<Props> = ({ game, image, size }) => (
  <BaseGameThumb
    game={game}
    link={
      <div
        className={cn("block", size === "auto" ? "w-full" : "shrink-0 w-fit")}
      >
        {image}
      </div>
    }
    size={size}
  />
);

export default ComingSoonGameThumb;
